<template>
	<div class="log">
		<div class="btnbox"></div>
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0" v-if="filtershow">
					<el-form-item label="">
						<el-select v-model="formfilter.shop_id" placeholder="请选择店铺" clearable>
							<el-option :label="v.mall_name || v.shop_name" :value="v.id" v-for="(v,k) in shop_list" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.out_no" placeholder="商品编号，款号"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.state" placeholder="状态">
							<el-option label="状态" value=""></el-option>
							<el-option label="成功" :value="1"></el-option>
							<el-option label="失败" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>
			
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column label="店铺名称" align="center" header-align="center" min-width="100px" fixed="left">
						<template slot-scope="scope">
							{{ getShopDisplayName(scope.row) }}
						</template>
					</el-table-column>
					<el-table-column label="图片" fixed="left" align="center" header-align="center" width="120px">
						<template slot-scope="scope">
							<div class="img">
								<img :src="getProductPic(scope.row)" v-if="getProductPic(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="good_no" label="商品编号" align="center" header-align="center" min-width="80px">
					</el-table-column>
					<el-table-column prop="good_out_no" label="外部编码" align="center" header-align="center" min-width="80px">
					</el-table-column>
					<el-table-column prop="good_pdd_cat_name" label="类目" align="center" header-align="center" min-width="60px">
					</el-table-column>
					<el-table-column prop="state_str" label="状态" align="center" header-align="center" min-width="40px">
					</el-table-column>
					<el-table-column label="成功信息" align="center" header-align="center" min-width="120" class-name="msg-column">
						<template slot-scope="scope">
							<el-popover
								v-if="scope.row.success_msg"
								trigger="hover"
								placement="top"
								width="360"
								popper-class="log-msg-popover"
							>
								<div class="log-msg-popover__content">{{ scope.row.success_msg }}</div>
								<el-button type="text" size="mini" @click="oncopy(scope.row.success_msg)">复制</el-button>
								<div slot="reference" class="msg-cell">{{ scope.row.success_msg }}</div>
							</el-popover>
							<span v-else>-</span>
						</template>
					</el-table-column>
					<el-table-column label="错误信息" align="center" header-align="center" min-width="120" class-name="msg-column">
						<template slot-scope="scope">
							<el-popover
								v-if="scope.row.err_msg"
								trigger="hover"
								placement="top"
								width="360"
								popper-class="log-msg-popover"
							>
								<div class="log-msg-popover__content">{{ scope.row.err_msg }}</div>
								<el-button type="text" size="mini" @click="oncopy(scope.row.err_msg)">复制</el-button>
								<div slot="reference" class="msg-cell">{{ scope.row.err_msg }}</div>
							</el-popover>
							<span v-else>-</span>
						</template>
					</el-table-column>
					<el-table-column prop="create_time_str" label="创建时间" align="center" header-align="center" min-width="70px">
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
				:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
				@current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'pddlog',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				filtershow: true,
				formfilter: {
					shop_id: "",
					out_no: "",
					state: ""
				},
				shop_list: []
			}
		},
		
		inject: ['onimgarr', 'oncopy'],
		
		mounted() {
			this.onlist();
			this.onshop();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},
		
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},
		
		methods: {
			onfilter() {
				this.page = 1;
				this.onlist();
			},
			
			onreset() {
				this.formfilter = {
					shop_id: "",
					out_no: "",
					state: ""
				};
				this.page = 1;
				this.onlist();
			},
			
			handleCurrentChange() {
				this.onlist();
			},
					
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},
			
			onlist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.page = this.page;
				obj.limit = this.pageSize;
					
				this.$axios.post('api/user/pdd_add_good_log', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onshop() {
				var obj = {
					page: 1,
					limit: 99999
				};
								
				this.$axios.post('api/retail_shop/list', obj).then(res => {
					if (res.data.code == 0) {
						this.shop_list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			getShopDisplayName(row) {
				if (row.mall_name || row.shop_name) {
					return row.mall_name || row.shop_name
				}
				var shop = this.shop_list.find(function(item) {
					return item.id == row.shop_id
				})
				return shop ? (shop.mall_name || shop.shop_name) : '-'
			},

			getProductPic(row) {
				var pics = this.onimgarr(row.product_pic)
				return pics.length > 0 ? pics[0] : ''
			},
		}
	}
</script>

<style scoped lang="less">
	.log {
		height: 100%;
	}
	
	.tablebox {
		height: calc(100% - 72px);
	}
	
	.img {
		width: 100px;
		img {
			width: 100%;
		}
	}

	.msg-cell {
		height: 48px;
		line-height: 24px;
		overflow: hidden;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		word-break: break-all;
		text-align: left;
		cursor: pointer;
	}

	/deep/ td.msg-column .cell {
		white-space: normal;
	}
</style>

<style lang="less">
.log-msg-popover__content {
	max-height: 200px;
	overflow-y: auto;
	word-break: break-all;
	line-height: 1.5;
	margin-bottom: 8px;
}


// WEBPACK FOOTER //
// src/components/pdd/log.vue